import * as React from 'react'

function SvgAsset48(props) {
  return (
    <svg viewBox="0 0 220 220" {...props}>
      <defs>
        <mask
          id="Asset48_svg__a"
          x={0}
          y={0}
          width={220}
          height={220}
          maskUnits="userSpaceOnUse"
        >
          <path fillRule="evenodd" fill="#fff" d="M0 0h220v220H0V0z" />
        </mask>
      </defs>
      <g data-name="Layer 2">
        <g mask="url(#Asset48_svg__a)" data-name="Layer 1">
          <path
            d="M110 137.5a27.5 27.5 0 1127.5-27.5 27.5 27.5 0 01-27.5 27.5m0-82.5a55 55 0 1055 55 55 55 0 00-55-55m0 137.5a82.5 82.5 0 1182.5-82.5 82.5 82.5 0 01-82.5 82.5M110 0a110 110 0 10110 110A110 110 0 00110 0"
            fillRule="evenodd"
          />
        </g>
      </g>
    </svg>
  )
}

export default SvgAsset48
